import dayjs from "dayjs"
import RexService from "services/rexService"
import { ICommissionDiscrepancy, IListingDiscrepancy } from "types/rex"

export interface IDiscrepancyRequest {
  periodStart: string
  periodEnd?: string
  filterByAnniversaryDate: boolean
}

export const getContractCommissionDiscrepancies = async (
  request: IDiscrepancyRequest,
  getAuthToken: () => Promise<string>
): Promise<ICommissionDiscrepancy[] | undefined> => {
  const token = await getAuthToken()
  
  const service = new RexService(token)

  const result = await service.rexService.get('GetContractCommissionDiscrepancies',{
    periodStart: dayjs(request.periodStart).format('YYYY-MM-DD'),
    periodEnd: dayjs(request.periodEnd).format('YYYY-MM-DD'),
    filterByAnniversaryDate: request.filterByAnniversaryDate,
  })

  return result.data || []
}


export const getListingDiscrepancies = async (
  request: IDiscrepancyRequest,
  getAuthToken: () => Promise<string>
): Promise<IListingDiscrepancy[] | undefined> => {
  const token = await getAuthToken()
  
  const service = new RexService(token)

  const result = await service.rexService.get('GetListingDiscrepancies',{
    periodStart: dayjs(request.periodStart).format('YYYY-MM-DD'),
    periodEnd: dayjs(request.periodEnd).format('YYYY-MM-DD'),
    filterByAnniversaryDate: request.filterByAnniversaryDate,
  })

  return result.data || []
}